import { QueryBase } from '../../../common/model/query-base';

export class Rs2UsersQuery extends QueryBase {
  searchString = '';
}
